package com.esoris.esocomponent.ui.defaultvalue

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

object EsoSpacing {
    // Base spacing values
    val small = 4.dp
    val medium = 8.dp
    val large = 16.dp
    val extraLarge = 24.dp

    // ----- Vertical Spacers -----

    @Composable
    fun SmallVertical() = Spacer(Modifier.height(small))

    @Composable
    fun MediumVertical() = Spacer(Modifier.height(medium))

    @Composable
    fun LargeVertical() = Spacer(Modifier.height(large))

    @Composable
    fun ExtraLargeVertical() = Spacer(Modifier.height(extraLarge))


    // ----- Horizontal Spacers -----

    @Composable
    fun SmallHorizontal() = Spacer(Modifier.width(small))

    @Composable
    fun MediumHorizontal() = Spacer(Modifier.width(medium))

    @Composable
    fun LargeHorizontal() = Spacer(Modifier.width(large))

    @Composable
    fun ExtraLargeHorizontal() = Spacer(Modifier.width(extraLarge))

}

